import { DesignProp } from "../PropCategories";

export const sizing = {
  name: "Sizing",
  nameI18n: "builder_ui.prop_type.styles.sizing",
  category: [DesignProp],
  type: "sizing",
  defaultValue: {
    width: "100%",
    height: "100%",
    minWidth: "100px",
    minHeight: "40px",
    maxWidth: "100px",
    maxHeight: "40px",
  },
} as const;
